import { subscriptionContractRentSale } from '../../api/contract_rent_sale/subscription_contract_rent_sale';
import { IServerError } from '../../api/types';
import { IThunkActionCreator } from '../index';
import { saveAuthorizedUser } from '../offer';

import { IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export interface IContractRentSaleState {
  messageError: string;
  statusFetch: TStatusFetch;
}

export type TStatusFetch = 'none' | 'isLoad' | 'ok' | 'error';

export interface IContractRentSaleFetch {
  payload: {
    messageError: string;
    statusFetch: TStatusFetch;
  };
  type: 'IContractRentSaleFetch';
}

export interface IContractRentSaleFetchSuccess {
  payload: {
    messageError: string;
    statusFetch: TStatusFetch;
  };
  type: 'IContractRentSaleFetchSuccess';
}

export interface IContractRentSaleFetchError {
  payload: {
    messageError: string;
    statusFetch: TStatusFetch;
  };
  type: 'IContractRentSaleFetchError';
}

export interface IContractRentSaleClearState {
  type: 'IContractRentSaleClearState';
}

export interface IContractRentSaleResponse {
  auth: boolean;
  subscribe: boolean;
  user?: IUserSchema;
}

export function contractRentSaleClearState(): IContractRentSaleClearState {
  return {
    type: 'IContractRentSaleClearState',
  };
}

export function contractRentSaleSetError(statusFetch: TStatusFetch, messageError: string): IContractRentSaleFetchError {
  return {
    payload: {
      messageError,
      statusFetch,
    },
    type: 'IContractRentSaleFetchError',
  };
}

export function submitSubscriptionContractRentSale(
  host: string,
  email: string,
  docType: string,
  subscribeNews: boolean,
): IThunkActionCreator {
  return (dispatch, getState, context) => {
    dispatch({
      payload: {
        messageError: '',
        statusFetch: 'isLoad',
      },
      type: 'IContractRentSaleFetch',
    });

    subscriptionContractRentSale(context.makeRequest, host, email, docType, subscribeNews)
      .then((response: IContractRentSaleResponse) => {
        if (response && response.user) {
          dispatch(saveAuthorizedUser(response.user));
        }

        if (window.__reloadHeader__) {
          window.__reloadHeader__();
        }

        dispatch({
          payload: {
            messageError: '',
            statusFetch: 'ok',
          },
          type: 'IContractRentSaleFetchSuccess',
        });
      })
      .catch((error: IServerError) => {
        dispatch(contractRentSaleSetError('error', 'Не удалось отправить договор. Попробуйте еще раз.'));
      });
  };
}

export type TContractsRentSaleActions = IContractRentSaleFetch |
  IContractRentSaleFetchSuccess |
  IContractRentSaleFetchError |
  IContractRentSaleClearState;

const initialState = {
  messageError: '',
  statusFetch: 'none' as 'none',
};

export function contractRentSaleReducer(
  state: IContractRentSaleState = initialState,
  action: TContractsRentSaleActions,
): IContractRentSaleState {
  switch (action.type) {
    case 'IContractRentSaleFetch':
    case 'IContractRentSaleFetchSuccess':
    case 'IContractRentSaleFetchError':
      return {
        ...state,
        messageError: action.payload.messageError,
        statusFetch: action.payload.statusFetch,
      };

    case 'IContractRentSaleClearState':
      return {
        ...state,
        messageError: '',
        statusFetch: 'none',
      };

    default:
      return state;
  }
}
